<template>
	<div class="menu-notification py-3 d-flex gap-3 align-items-center" :data-notification-id="data.notification_id">
		<div class="notification-text d-flex flex-column justify-content-between flex-grow-1">
			<div class="d-flex gap-2">

				<div class="d-flex gap-2 align-items-center">
					<div class="thumb" :style="`background: url(${getIcon()});`"></div>
					<div class="d-flex">
						<span class="author">
							{{ category }} 
							<span class="description">{{ getText() }}</span>
							<span v-if="data.is_group"> {{ data.object ? data.object.name : '' }}</span>
						</span>
					</div>
				</div>

			</div>
		</div>
        <div class="notifications-actions">
			<div ref="actions_dropdown" class="ui right pointing suidropdown icon button">
				<i class="ellipsis vertical icon"></i>
				<div class="menu">
					<div class="item" @click="markAsReed">{{ $i18n.t('notification.delete') }}</div>
				</div>
			</div>
		</div>
        <div class="notifications-actions-full" @click="openMessage"></div>
	</div>
</template>

<script>
let emitter = require('tiny-emitter/instance');
import axios from 'axios';
import { mapGetters } from "vuex";  // mapActions
export default {
	name: "PrivateMessage",
	props: {
		data		: [],
		category	: { type: String, default: '' },
	},
	data() {
		return {
			notificationId: 0
		}
	},
    computed: {
        ...mapGetters([
            'logged', 'token', 'pm_groups'
        ]),
    },
	beforeMount() {
		// console.log('DASDASDAS', this.data); // pm_group_system
		let vm              = this;
		vm.notificationId   = vm.data.notification_id ?? vm.data.object.notification_id;
	},
    mounted() {
		window.$(this.$refs.actions_dropdown).suidropdown({
			// transition: 'drop'
		});
	},
	methods: {
		getIcon() {
            console.log("getIcon: ", this.data);

			if( this.data.is_group && this.data.object?.thumbnail) {
				return this.data.object.thumbnail;
			}
			return this.data.icon;
		},
		getText() {
			if( this.data.text ) {
				return this.data.text.replace(this.data.nickname, "");
			}
			return '';
		},
        markAsReed() {
            let vm          = this;
            let headers     = { 'Content-Type': 'application/json;charset=UTF-8', 'Access': 'application/json', language: vm.$i18n.locale, Authorization : `Bearer ${vm.token}`};
            let form_data   = new FormData();
            // vm.$app.wait(true);
            window.$(vm.$refs.actions_dropdown).addClass('loading');
            form_data.append('notification', vm.notificationId);
			form_data.append('no_timestamp', true);
            axios.post(vm.$url_api + 'api/ReedNotification', form_data, { headers:headers })
                .then(response => {
                    response;
                    vm.removeNotification();
                })
                .catch(error => {
                    console.log('error', error.response.data)
                })
                .finally(response => {
                    response;
                    // vm.$app.wait(false);
                    window.$(vm.$refs.actions_dropdown).removeClass('loading');
                });
        },
		removeNotification() {
			// 1 - find the index of the notification with the matching ID
			const index = this.$app.notification_list.findIndex(notification => notification.notification_id === this.notificationId);
			// 2 - if found, remove it from the array
			if( index !== -1 ) { this.$app.notification_list.splice(index, 1); }
		},
        sendEmitterToOpenMessage() {
            let payload = {
                "title"         : (!this.data.is_group) ? this.data.nickname    : this.data.object.name,
                "thumb"         : (!this.data.is_group) ? this.data.icon        : this.data.object.thumbnail,
                "isGroup"       : this.data.is_group,
                // "status"        : true,
                "recipientId"   : (!this.data.is_group) ? this.data.friend_id   : this.data.object.id,
            };
            emitter.emit('MenuInbox::message::open', payload);
            console.log('CLICK', payload);
        },
        openMessage() {
            // grupo nao esta habilitado no sistema
            if( !this.pm_groups ) {
                window.$.toast({
                    // title: 'Erro!',
                    message: this.$t('notification.group.group_disabled'),
                    class: 'error',
                    showIcon: 'times',
                    showProgress: 'top'
                });
                return;
            }
            if( this.data.is_group ) {
                this.checkUserBelongsToGroup(this.data.object.id); 
            } else {
                this.sendEmitterToOpenMessage();
            }
        },
        async checkUserBelongsToGroup(groupId){
            let headers = {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access': 'application/json',
                language: this.$i18n.locale,
                Authorization: `Bearer ${this.token}`
            };
            let url     = this.$url_api + 'api/pm/group/' + groupId + '/user';
            return axios.get(url, { headers })
                .then(response => {
                    response;
                    this.sendEmitterToOpenMessage();
                })
                .catch(error => {
                    let st = '';
                    for (let o in error.response.data.data) {
                        st += (error.response.data.data[o] + '<br>');
                    }
                    window.$.toast({
                        // title: 'Erro!',
                        message: st,
                        class: 'error',
                        showIcon: 'times',
                        showProgress: 'top'
                    });
                });
        }
	}
}
</script>

<style scoped lang="scss">
    .menu-notification {
        flex-grow: 1;
        position: relative;
        // cursor: default;

        .done {
            cursor: pointer;
            color: var(--buttons_color);
            font-size: 25px;
            position: relative;
            &:before {
                content: "";
                position: absolute;
                top: -10px;
                bottom: -10px;
                left: -10px;
                right: -10px;
            }
        }

        .notification-icon {
            width: 140px;
            height: 89px;
            flex-shrink: 0;
            border-radius: 10px;
            background: #F6F6F6;
        }

        .notification-text {
            .title {
                color: var(--buttons_color);
                font-family: "Hanken Grotesk", sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                display: flex;
                align-items: center;
            }
            .author {
                font-family: "Open Sans", sans-serif;
                font-size: 1rem;
                font-weight: 600;
                line-height: 19px;
                color: var(--buttons_color) !important;
                margin-left: 5px !important;
            }
            .description {
                font-family: "Open Sans", sans-serif;
                font-weight: 400;
                font-size: 0.95rem !important;
                line-height: 19px;
                color: #393939 !important;
            }
            .thumb {
                width: 48px;
                height: 48px;
                border-radius: 100%;
                position: relative;
                background-size: cover !important;
                background-position: center !important;
                background-repeat: no-repeat !important;
                background-blend-mode: saturation;
                flex-shrink: 0;
            }
            .icon-container {
                width: 49px;
                height: 49px;
                flex-shrink: 0;
                border-radius: 54px;
                position: relative;
                background-color: #F0F0F0;
                .material-symbols-outlined {
                    color: #FFFFFF !important;
                }
            }
        }

        &.pendent {
            background-color: #00C4FF1F;
            &:hover {
                background-color: #F9F9F9;
            }
        }

        &.viewed {
            background-color: #FFFFFF;
            &:hover {
                background-color: #F9F9F9;
            }
        }

        &.new-notification {
            background-color: pink;
        }

        .material-symbols-outlined {
            font-variation-settings:
                'FILL' 1,
                'wght' 400,
                'GRAD' 0,
                'opsz' 24
        }

        .notifications-actions{
            position:absolute;
            top: 3px;
            right: 2px;
            line-height: 0;
            z-index: 2;
            .ui.suidropdown{
                padding: 0px !important;
                background: none;
                margin: 0 !important;
                .icon{
                    color: #b5b5b5;
                }
            }

            .ui.right.pointing.suidropdown > .menu{
                margin: 0px;
                &::after{
                    display: none;
                }
                .item{
                    font-size: 12px;
                }
            }
        }

        .notifications-actions-full{
            position:absolute;
            width: 100%;
            height: 100%;
            cursor: pointer;
            z-index: 1;
        }

    }
</style>